<template>
    <transition name="roll-fade">
        <div v-if="show" class="popover_helper">
            <div class="popover" :style="popoverSettings">
                <div class="popover-content" v-html="msg"></div>
            </div>
        </div>
    </transition>
</template>
<script>

import { eventBus } from "../../eventbus.js";
var vm = [];
function setGlobalOffset(){
  for(var i = 0; i < vm.length; i++){
    vm[i].getPositioning()
  }  
}

$(window).resize(function() {
  setGlobalOffset();
});
setTimeout(function(){
  // fix bug in prod
  setGlobalOffset();
}, 1000)

export default {
  props: {
    helpProp: String,
    offset: Object,
    reference: String,
    msg: String
  },
  mounted: function() {
    this.$root.subscribe(this.helpProp);
    vm.push(this);
    this.$nextTick(function(){
      if (this.reference != null) {
        this.getPositioning();
      }
    })
  },
  created: function(){
    eventBus.$on("toggleHelper", this.isActive)
  },
  watch: {
    helpProp: function() {
      this.$root.subscribe(this.helpProp);
      if (this.reference != null) {
        this.getPositioning();
      }
    }
  },
  data: function() {
    return {
      popoverSettings: {},
      show: false,
      marginBottom: null
    };
  },
  methods: {
    isActive: function(name){
      if(name == this.helpProp){
        this.show = this.$root.helpers[this.helpProp];
      } else {
        this.show = false;
      }
    },
    getPositioning: function() {
      var jq = $("#" + this.reference)
      var pos = jq.position();
      //console.log(this.reference, '- jq position: ', pos)
      if(this.reference == 'father_detail'){
        pos = {
          top: 0, 
          left: 0
        }
      }
      if(pos){
        for (var prop in this.offset) {
          if (pos[prop] != null && this.offset[prop] != null) {
            pos[prop] = pos[prop] + this.offset[prop];
          }
        }
        if(this.offset.leftOffset){
          
          pos.left = window.innerWidth - this.offset.leftOffset;
        }
        this.popoverSettings = {
          top: pos.top + "px",
          left: pos.left + "px"
        };
        this.$forceUpdate();
      }
      this.marginBottom = "0px";
      if(jq.css("position") == "absolute"){
        if(jq.css("bottom") != "auto"){
          //this.popoverSettings.top = "auto";
          //this.popoverSettings.bottom = jq.css("bottom");
          if(this.offset != null && this.offset.bottom != null){
            this.marginBottom = this.offset.bottom + "px";
          }
        } 
      }
      this.popoverSettings["margin-bottom"] = this.marginBottom;
    }
  }
};
</script>
<style scoped>
.popover_helper > .popover {
  display: inline; /*block;*/
  position: absolute;
  border-radius: 3px;
  background-color: #3c8dbc;
  color: white;
  z-index: 999999;
}
.popover_helper > .popover > .popover-content {
  min-width: 200px;
  border-radius: 3px;
}

.roll-fade-enter {
  opacity: 0;
}

.roll-fade-enter-active {
  transition: opacity 0.2s;
}

.roll-fade-leave-active {
  transition: opacity 0.2s;
  opacity: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/dynamic/HelpPopover.vue?14a68da5